import { reduxKey } from './constants';
import { reduxKey as reduxKeyNew } from '../../CommentEditor.editor_v3/redux/constants';
import { flagEnabled } from '@wix/da-react-context/pkg/flags/redux/selectors';
export const getEditorSlice = (state, editorId)=>{
    const branchedReduxKey = flagEnabled(state, 'editor_comment') ? reduxKeyNew : reduxKey;
    return state[branchedReduxKey] && state[branchedReduxKey][editorId] || {};
};
export const isBusy = (state, editorId)=>{
    var _getEditorSlice_isBusy;
    return (_getEditorSlice_isBusy = getEditorSlice(state, editorId)['isBusy']) !== null && _getEditorSlice_isBusy !== void 0 ? _getEditorSlice_isBusy : false;
};
export const getPublishResult = (state, editorId)=>getEditorSlice(state, editorId)['publishResult'];
export const isError = (state, editorId)=>getEditorSlice(state, editorId)['isError'];
export const getErrorMsg = (state, editorId)=>getEditorSlice(state, editorId)['errorMsg'];
export const getIsFocusRequested = (state, editorId, defaultValue = false)=>{
    const focus = getEditorSlice(state, editorId)['isFocusRequested'];
    if (focus === undefined) {
        return defaultValue;
    }
    return focus;
};

//# sourceMappingURL=selectors.js.map